import { render, staticRenderFns } from "./password-dialog.vue?vue&type=template&id=36e0145e&"
import script from "./password-dialog.vue?vue&type=script&lang=js&"
export * from "./password-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports